import type { ApplyAccountListParams } from './types'

import type { PagingRequest } from '#/api/type'

import { defineApi } from '#/api/define-api'
import { requestClient } from '#/api/request'
import { formatDateRange } from '#/utils'

export interface BindAdsAccountParams {
  requstId: string
  agency: string
  remark?: string
}
export interface UpdateApplyAccountParams {
  taskId: null | number
  requestId?: string
  customerId?: string
  agency?: string
  operationType: number
  accounts?: {
    accountId: string
    accountName: string
  }[]
  remark?: string
}

export const applyAccountApi = defineApi('operation', ({ prefix }) => {
  function getApplyAccountListParams(
    params: PagingRequest<ApplyAccountListParams>,
  ) {
    return {
      createdTime: formatDateRange(params.condition.createdTime),
      userID: params.condition.userID
        ? Number(params.condition.userID)
        : undefined,
      customerId: params.condition.customerId
        ? Number(params.condition.customerId)
        : undefined,
      nickname: params.condition.nickname,
      customerStatus: Number(params.condition.customerStatus),
      status: Number(params.condition.status),
    }
  }

  function getApplyAccountList(params: PagingRequest<ApplyAccountListParams>) {
    params.condition = getApplyAccountListParams(params)
    params = {
      ...params,
      condition: getApplyAccountListParams(params),
    }
    return requestClient
      .post(prefix('openAdsAccountTask/query'), params)
      .then((res) => {
        return {
          items: res?.list || [],
          total: res?.total || 0,
        }
      })
  }
  function getApplyAccountTotal() {
    return requestClient.get(prefix('openAdsAccountTask/total')).then((res) => {
      return {
        pendingCount: res.pendingCount,
        processingCount: res.processingCount,
        completedCount: res.completedCount,
        growthRate: res.growthRate,
        failedCount: res.failedCount,
      }
    })
  }
  function deleteApplyAccount(params: { taskId: number; auditReason: string }) {
    return requestClient.post(prefix('openAdsAccountTask/delete'), params)
  }
  function unbindAdsAccount(params: { ids: string[] }) {
    return requestClient.post(prefix('adsAccount/adsAccountUnbind'), params)
  }
  function adsAccountAllocation(params: { ids: number[]; companyId: number }) {
    return requestClient.post(prefix('adsAccount/adsAccountAllocation'), params)
  }

  function bindAdsAccount(params: BindAdsAccountParams) {
    return requestClient.post(prefix('openAdsAccountTask/bind'), params)
  }
  // /operation/openAdsAccountTask/update
  // "taskId": 2,
  // "requestId": "1267002694942715",
  // "agency": "madhouse",
  // "operationType": 1
  function updateApplyAccount(params: UpdateApplyAccountParams) {
    params =
      params.operationType === 1
        ? {
            taskId: params.taskId,
            requestId: params.requestId,
            agency: params.agency,
            operationType: params.operationType,
            remark: params.remark,
          }
        : {
            taskId: params.taskId,
            operationType: params.operationType,
            accounts: params.accounts,
            remark: params.remark,
          }
    return requestClient.post(prefix('openAdsAccountTask/update'), params)
  }

  function getAdsAccountList(params: {
    pageIndex: number
    pageSize: number
    condition: {
      account: null | string
      mediaPlatform?: null | string[]
    }
  }) {
    return requestClient
      .post(prefix('adsAccount/allAdsAccount'), params)
      .then((res) => {
        return {
          list: res.list?.map((item: any) => ({
            id: String(item.id),
            accountName: item.accountName,
            accountId: item.accountId,
            customerId: item.customerId,
            isAllocation: item.isAllocation,
            reason: item.reason,
            mediaPlatform: item.mediaPlatform,
            nickname: item.nickname,
          })),
          total: res?.total,
        }
      })
  }

  return {
    getApplyAccountList,
    getApplyAccountTotal,
    deleteApplyAccount,
    unbindAdsAccount,
    adsAccountAllocation,
    bindAdsAccount,
    updateApplyAccount,
    getAdsAccountList,
    getApplyAccountListParams,
  }
})
